// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsuranceOutlinedSvg from "@fishx/icons-svg/es/asn/InsuranceOutlined";
import FishxIcon from '../components/FishxIcon';

var InsuranceOutlined = function InsuranceOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceOutlinedSvg
  }));
};

InsuranceOutlined.displayName = 'InsuranceOutlined';
export default React.forwardRef(InsuranceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsuranceOutlined.js
// module id = 2992
// module chunks = 0